export enum OccurrenceUnit {
    Days = 'days',
    Weeks = 'weeks',
    Months = 'months',
    Quarters = 'quarters',
    Years = 'years',
}